const ITEMS = [
  { text: "OTET Paper 1 & 2 — 2026 Batch", odia: false },
  { text: "ସା ବିଦ୍ୟା ଯା ବିମୁକ୍ତୟେ ।", odia: true },
  { text: "Jyoti Academy", odia: false },
  { text: "Knowledge is that which liberates", odia: false },
  { text: "ତମସୋ ମା ଜ୍ୟୋର୍ତିଗମୟ ।", odia: true },
  { text: "From darkness, lead me to light", odia: false },
  { text: "ଜ୍ୟୋତି ଏକାଡେମୀ", odia: true },
];

export const Marquee = () => {
  const doubled = [...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div className="relative overflow-hidden border-y border-sky-800/20 bg-sky-800 py-4" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max items-center">
        {doubled.map((item, i) => (
          <span key={i} className="flex items-center">
            <span
              className={
                item.odia
                  ? "font-odia text-lg text-amber-200"
                  : "font-mono text-xs font-semibold uppercase tracking-[0.35em] text-sky-100"
              }
            >
              {item.text}
            </span>
            <span className="mx-10 h-1.5 w-1.5 rounded-full bg-amber-300" aria-hidden />
          </span>
        ))}
      </div>
    </div>
  );
};
